// components/ReusableSearchBar.jsx
import { useState } from "react";
import {
  InputGroup,
  Input,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";

export default function ReusableSearchBar({
  placeholder = "검색어를 입력하세요",
  onSearch,
  width = "320px",
  defaultValue = "",
}) {
  const [keyword, setKeyword] = useState(defaultValue);

  const run = () => onSearch?.(keyword.trim());
  const onKey = (e) => e.key === "Enter" && run();

  return (
    <InputGroup maxW={width}>
      <Input
        placeholder={placeholder}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={onKey}
        bg="white"
      />
      <InputRightElement>
        <IconButton
          w="100%"
          height="100%"
          aria-label="search"
          bgColor="#E8EAEC"
          icon={<SearchIcon />}
          size="sm"
          onClick={run}
          variant="ghost"
        />
      </InputRightElement>
    </InputGroup>
  );
}
